const WaitingFooter = () => {
  return (
    <div className="text-center">
      <p className="text-[15px] text-[#666666]">
        Questions? Reach us on WhatsApp or at{' '}
        <a href="mailto:info@trrip.live" className="text-[#3B82F6] hover:underline">
          info@trrip.live
        </a>
      </p>
    </div>
  );
};

export default WaitingFooter;
